module.exports = __webpack_public_path__ + "static/salon-pasajeros--iluminacion-4c9766ee7664f041a80b47a1f920a0c6.jpg";